import { Directive, ElementRef, Host, inject, Input, OnInit } from '@angular/core';
import { CeParameterListComponent } from '../ce-parameter-list.component';

@Directive({
    selector: '[ceParameterLabel]',
    standalone: true,
    host: {
        class: 'flex-middle',
        '[class.u-color-text-secondary]': '!hasCustomColorClass',
        '[class.u-text-label-sm]': 'this.parent.size === "default"',
        '[class.u-text-label-xs]': 'this.parent.size === "small"',
    },
})
export class CeParameterLabelDirective implements OnInit {
    @Input() required = false;

    @Host() public parent = inject(CeParameterListComponent);
    readonly #elem = inject(ElementRef);

    hasCustomColorClass = false;

    ngOnInit(): void {
        if (this.required) {
            this.#elem.nativeElement.classList.add('isRequired');
        }

        // Check if a custom color class is already applied
        const element = this.#elem.nativeElement as HTMLElement;
        const colorClasses = ['u-color-text-primary', 'u-color-text-disabled', 'u-color-text-tertiary'];
        this.hasCustomColorClass = colorClasses.some(cls => element.classList.contains(cls));
    }
}

@Directive({
    selector: '[ceParameterItemValue]',
    standalone: true,
    host: {
        '[class.u-text-body-md]': 'this.parent.size === "default"',
        '[class.u-text-body-sm]': 'this.parent.size === "small"',
    },
})
export class CeParameterItemValueDirective {
    @Host() public parent = inject(CeParameterListComponent);
}

@Directive({
    selector: '[ceParameterItemSecondary]',
    standalone: true,
    host: {
        '[class.u-text-body-md]': 'this.parent.size === "default"',
        '[class.u-text-body-sm]': 'this.parent.size === "small"',
    },
})
export class CeParameterItemSecondaryDirective {
    @Host() public parent = inject(CeParameterListComponent);
}
